<template>
	<div>
		<div class="list-btn">

		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="add(row.id,row.name)">入库</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="quit(row.id,row.name)">出库</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="details(row.id)">详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading:false, 
				total: 0,
				query: {
					page: 0,
					size: 10
				},
				columns12: [
					{
						title: '图片',
						key: 'url',
						width: 136,
						render: (h, params) => {
							const row = params.row;
							
							return h('div', [
								h('img', {
									style: {
										width: "100px",
										height:'100px',
										verticalAlign: "middle"
									},
									attrs: {
										src: params.row.imgUrl
									}
								}, )
							]);
						}
					},
					{
						title: 'id',
						key: 'id'
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '类型',
						key: 'operComType',
						render: (h, params) => {
							return h("div", params.row.operComType.name)
						}
					},
					{
						title: '进价',
						key: 'purchasingPrice',
						render: (h, params) => {
							return h("div", params.row.purchasingPrice / 100 + '元')
						}
					},
					{
						title: '售价',
						key: 'sellPrice',
						render: (h, params) => {
							return h("div", params.row.sellPrice / 100 + '元')
						}
					},
					{
						title: '单位',
						key: 'unit'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 250,
						align: 'center'
					}
				],
				data6: []

			}
		},
		methods: {
			details(id) { //详情

				this.$router.push({
					name: 'oper/repertory/details',
					query: {
						id: id
					}
				})
			},
			add(id,name) { //入库
				this.$router.push({
					name: 'oper/repertory/add',
					query: {
						id: id,
						name:name
					}
				})
			},
			quit(id,name) { //出库
				console.log(id)
				this.$router.push({
					name: 'oper/repertory/delete',
					query: {
						id: id,
						name:name
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComMerchandise/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/repertory/list.vue